const TerminPage = () => {
	return (
		<h1>Termine</h1>
	);
}

export default TerminPage;